import _ from 'lodash';
import React from 'react';
import PropTypes from 'prop-types';

import './styles';

const FEATURES = [
  {
    icon: require('./whitelabel.png'),
    header: 'COMPETITIVE PRICING',
    description: 'Our technology enables us to offer the best pricing in the industry',
  },
  {
    icon: require('./mix-match.png'),
    header: 'THOUSANDS OF PRODUCTS',
    description: 'Choose from thousands of products from top brands',
  },
  {
    icon: require('./shirts.png'),
    header: 'SINGLE INVOICE SOLUTION',
    description: 'Blanks, printing, and whitelabel fulfillment in a single invoice',
  },
];

export default class Features extends React.Component {
  static propTypes = {
  }

  state = {}

  render() {
    return (
      <div className="Features">
        <div className="p-v-2" />
        <div className="ui container">
          <div className="ui three column stackable grid">
            {_.map(FEATURES, (feature, index) => (
              <div className="column" key={index}>
                <div className="ui grid">
                  <div className="three wide computer three wide tablet two wide mobile column">
                    <div className="ui fluid image">
                      <img src={feature.icon} />
                    </div>
                  </div>
                  <div className="nine wide computer nine wide tablet ten wide mobile column">
                    <h3 className="m-b-1">{feature.header}</h3>
                    <div className="description fs-3">
                      {feature.description}
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
        <div className="p-v-2" />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./app/pages/HomePage2/Features/index.jsx